import React, { Component } from 'react';
import {
  withAuthenticator
} from 'aws-amplify-react';
import {
  SignIn,
  ConfirmSignIn,
  ForgotPassword,
  RequireNewPassword
} from 'components/Authentication';
import './App.css';
import LoadConfig from 'components/LoadConfig';
import Query from 'components/Query';
import {
  MainNavigation
} from 'components/Layout';

class App extends Component {
  async componentDidMount() {
    document.body.classList.add('authenticated');
  }

  componentWillUnmount() {
    document.body.classList.remove('authenticated');
  }

  render() {
    return (
      <LoadConfig>
        <MainNavigation />
        <Query />
      </LoadConfig>
    )
  }
}

export default withAuthenticator(App, false, [
  <SignIn/>,
  <ConfirmSignIn/>,
  <ForgotPassword/>,
  <RequireNewPassword/>
]);



// WEBPACK FOOTER //
// ./src/App.js